import Vue from 'vue';
import VueI18n from 'vue-i18n';
import provider from '@/api/apollo-client';
import { gql } from '@apollo/client/core';

Vue.use(VueI18n);

export const i18n = new VueI18n();

export async function loadLanguageAsync() {
  return new Promise(resolve => {
    const getTranslations = gql`
      query getTranslations {
        translations {
          query
          key
          en
          ru
          cn
          th
        }
      }
    `;
    provider
      .query({
        query: getTranslations,
        fetchPolicy: 'no-cache'
      })
      .then(res => {
        let types = new Set(res.data.translations.map(item => item.query));
        const q = {
          en: {},
          ru: {},
          cn: {},
          th: {}
        };

        types.forEach(item => {
          q.en[item] = {};
          q.ru[item] = {};
          q.th[item] = {};
          q.cn[item] = {};
        });

        res.data.translations.forEach(item => {
          q.en[item.query][item.key] = item.en;
          q.ru[item.query][item.key] = item.ru;
          q.th[item.query][item.key] = item.th;
          q.cn[item.query][item.key] = item.cn;
        });

        // TODO: Translation
        q.en.schedules = {
          name: 'Name',
          favourite: 'Favorite',
          enabled: 'Enabled',
          schedule: 'Schedule',
          lastExecution: 'Last execution',
          lastExecutionResult: 'Last execution result',
          tags: 'Tags'
        };

        i18n.setLocaleMessage('en', q.en);
        i18n.setLocaleMessage('ru', q.ru);
        i18n.setLocaleMessage('th', q.th);
        i18n.setLocaleMessage('cn', q.cn);

        i18n.locale = localStorage.getItem('lang') || 'en';
      })
      .finally(() => {
        resolve();
      });
  });
}
